import {
    REQUEST_UPDATE_USER,
    REQUEST_UPDATE_USER_FAILURE,
    REQUEST_UPDATE_USER_SUCCESS
} from "../../constant/UsersConstant";

const initialState = {
    updateUser: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateUserReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_USER:
            return {
                ...state,
                updateUser: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_USER_SUCCESS:
            return {
                ...state,
                updateUser: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_USER_FAILURE:
            return {
                ...state,
                updateUser: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
